import { supabase } from "@/integrations/supabase/client";

export interface BlogListItem {
  id: string;
  title: string;
  slug: string;
  excerpt: string | null;
  featured_image_url: string | null;
  published_at: string | null;
}

export interface BlogPostRecord extends BlogListItem {
  content: string | null;
  updated_at: string;
  seo_title: string | null;
  seo_description: string | null;
}

export async function fetchBlogList(): Promise<BlogListItem[]> {
  const { data } = await supabase
    .from("published_cms_posts")
    .select("id, title, slug, excerpt, featured_image_url, published_at")
    .eq("status", "published")
    .eq("type", "blog")
    .order("published_at", { ascending: false });
  return data ?? [];
}

export async function fetchBlogPost(slug: string): Promise<BlogPostRecord | null> {
  const { data } = await supabase
    .from("published_cms_posts")
    .select(
      "id, title, slug, excerpt, content, featured_image_url, published_at, updated_at, seo_title, seo_description",
    )
    .eq("slug", slug)
    .eq("status", "published")
    .eq("type", "blog")
    .maybeSingle();
  return (data as BlogPostRecord | null) ?? null;
}

export async function fetchRelatedPosts(
  postId: string,
  curatedSlugs: string[] | undefined,
): Promise<BlogListItem[]> {
  const base = supabase
    .from("published_cms_posts")
    .select("id, title, slug, excerpt, featured_image_url, published_at")
    .eq("status", "published")
    .eq("type", "blog")
    .neq("id", postId);

  if (curatedSlugs && curatedSlugs.length) {
    const { data } = await base.in("slug", curatedSlugs);
    return curatedSlugs
      .map((s) => data?.find((r) => r.slug === s))
      .filter(Boolean) as BlogListItem[];
  }

  const { data } = await base.order("published_at", { ascending: false }).limit(3);
  return data ?? [];
}
